import { useCallback, useState } from "react";

/**
 * Estado de "rail colapsado" (painel lateral de KPIs em Terceiros / Pintura
 * & Lacagem) — problema #16 / F8.
 *
 * - Persiste a escolha do usuário em localStorage por chave (cada página tem
 *   a sua, ex.: "pharuerp:rail-terceiros-colapsado").
 * - Sem preferência salva, nasce colapsado em telas estreitas (< 1280px) e
 *   expandido em telas largas — libera espaço pra tabela onde ela é mais
 *   apertada.
 */

const BREAKPOINT_COLAPSO_PADRAO = 1280;

function lerInicial(storageKey) {
  if (typeof window === "undefined") return false;
  try {
    const salvo = window.localStorage.getItem(storageKey);
    if (salvo === "1") return true;
    if (salvo === "0") return false;
  } catch {
    /* localStorage indisponível — cai no default por viewport */
  }
  return window.innerWidth < BREAKPOINT_COLAPSO_PADRAO;
}

export function useRailColapsado(storageKey) {
  const [colapsado, setColapsado] = useState(() => lerInicial(storageKey));

  const alternar = useCallback(() => {
    setColapsado((prev) => {
      const next = !prev;
      try {
        window.localStorage.setItem(storageKey, next ? "1" : "0");
      } catch {
        /* ignora quota/indisponível */
      }
      return next;
    });
  }, [storageKey]);

  return { colapsado, alternar };
}
